import { useCurrentUser } from "@qualio/ui-components";
import { useCurrentProduct } from "../useCurrentProduct";
import { useQuery } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "@design-controls/types";

export const useTraceability = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();
  const flags = useFlags();
  const traceabilityLimit = flags[FeatureFlags.TRACEABILITY_LIMIT];

  return useQuery({
    queryFn: () => {
      return designControlsApi.traceabilityMatrix(
        companyId,
        productId,
        traceabilityLimit,
      );
    },
    queryKey: ["TRACEABILITY", companyId, productId],
  });
};
